import type { MediaUploadResult } from '@gwc/shared';
import { api } from '../lib/api';

export const mediaApi = {
  /** Upload an image file; returns a servable URL to store on the entity. */
  upload: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.upload<MediaUploadResult>('/media', form);
  },
};
